
/**
 * 계정 상태
 */
export type GetUserById200Status = typeof GetUserById200Status[keyof typeof GetUserById200Status];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserById200Status = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED',
  DELETED: 'DELETED',
} as const;
